/**
 * Shared styling for every email-template control (#800).
 *
 * @philipc39 (2026-09-15): "change ALL 'Email template' boxes to the same
 * colour orange … the box is white with orange text. it should be orange with
 * black text as per every other dropdown." Previously the shared
 * {@link EmailTemplateMenu} trigger and the {@link EmailTemplateButtons} row
 * rendered white-background/orange-text, while the Transactions listing and
 * the standalone email buttons (Chequebook "Clear Cheque Counter", Call
 * History "Special category data") rendered solid orange with near-black text.
 * These constants are the single source of truth for the orange skin so every
 * surface — dropdown triggers, dropdown items' containers, single-template
 * buttons, and the standalone button row — is styled identically.
 */

/** The common PTSB-orange skin shared by every email-template control. */
const ORANGE_SKIN =
  "bg-[#FF703E] text-[#1D252C] font-['Arial',sans-serif] font-bold " +
  'hover:bg-[#e55a2a] transition-all ' +
  'focus:outline-none focus:ring-4 focus:ring-offset-2 focus:ring-[#005fcc]/20';

/**
 * Solid orange button used for a template surfaced as a standalone button —
 * matches the reference style of the "Special category data" button on the
 * Call History screen (envelope icon + bold label, min 44px tap target).
 */
export const EMAIL_TEMPLATE_BUTTON_CLASS = `inline-flex items-center justify-center gap-2 px-6 py-3 min-h-[44px] text-[16px] rounded-[4px] shadow-sm ${ORANGE_SKIN}`;

/**
 * Solid orange "Email templates ▾" dropdown trigger (the shared
 * {@link EmailTemplateMenu}), styled like every other top-right control.
 */
export const EMAIL_TEMPLATE_TRIGGER_CLASS = `w-full inline-flex items-center justify-between gap-2 px-4 py-3 min-h-[44px] text-[16px] rounded-md shadow-sm ${ORANGE_SKIN}`;

/** Compact solid-orange button used per template in the inline button row. */
export const EMAIL_TEMPLATE_ROW_BUTTON_CLASS = `inline-flex items-center gap-2 px-4 py-2 text-[14px] rounded-md ${ORANGE_SKIN}`;
